import React, { Component, useState, useEffect } from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import Keycloak from 'keycloak-js';
import Lib from './commons/lib';
// Containers
import Full from './containers/Full/Full'
// import Simple from './containers/Simple/'

// KEZDŐLAP [ / ]
import Kezdolap from './views/Kezdolap';

// DASHBOARD [ /dashboard ]
import Dashboard from './views/Dashboard';
import UzenetekBaseView from './views/Dashboard/Uzenetek/views/UzenetekBaseView';

// ESEMENYEK [ /esemenyek ]
import Esemenyek from './views/Esemenyek/Esemenyek';
import EloadasBase from './views/Esemenyek/Eloadas/EloadasBase';
import EloadasForm from './views/Esemenyek/Eloadas/EloadasForm';
import MusorBase from './views/Esemenyek/Musor/MusorBase';
import MusorForm from './views/Esemenyek/Musor/MusorForm';
import JegyBase from './views/Esemenyek/Jegy/JegyBase';

// JEGYERTEKESITES [ /jegyertekesites ]
import Jegyertekesites from './views/Jegyertekesites/helysziniertekesites/Jegyertekesites';
import JegyErtekesitesBase from './views/Jegyertekesites/helysziniertekesites/ErtekesitesBase';
import JegyeladasBase from './views/Jegyertekesites/helysziniertekesites/JegyeladasBase';
import ListakContent from './views/Jegyertekesites/lekerdezesek/ListakContent';
import EmailSablonContent from './views/Jegyertekesites/emailsablonok/EmailSablonContent';
import KulsokliensContent from './views/Jegyertekesites/helysziniertekesites/KulsokliensContent';


// TEREMBERLES [ /teremberles ]
import TeremberlesBase from './views/Teremberles/TeremberlesBase';

// JEGYELLENORZES [ /jegyellenorzes ]
import JegyellenorzesContent from './views/Jegyellenorzes/JegyellenorzesContent';

// KÉSZLET [ /keszlet ]
import Keszlet from './views/Keszlet';
import Keszletkezeles from './views/Keszlet/Keszletkezeles/Keszletkezeles';
import BevetelezesBase from './views/Keszlet/Keszletkezeles/components/Bevetelezes/BevetelezesBase';
import SelejtezesBase from './views/Keszlet/Keszletkezeles/components/Selejtezes/SelejtezesBase';
import KeszletcsokkenesBase from './views/Keszlet/Keszletkezeles/components/Keszletcsokkenes/KeszletcsokkenesBase';
import Keszletinformacio from './views/Keszlet/Keszletinformacio/KeszletinformacioLista';
// import RaktarkeszletBase from './views/Keszlet/Raktarkeszlet/RaktarkeszletBase';
import LeltarForm from './views/Keszlet/Keszletkezeles/components/Leltar/LeltarForm';

// BÜFÉ [ /bufe ]
import Bufe from './views/Bufe/Bufe';
import BufeBase from './views/Bufe/Ertekesites/BufeBase';
import TermekekBase from './views/Bufe/Termekek/TermekekBase';
import ForgalomContent from './views/Bufe/Forgalom/ForgalomContent';
import EladasiLista from './views/Bufe/Eladasilista/EladasiLista';
import NTAKBase from './views/Bufe/NTAK/NTAKBase';

// RENDELÉS [ /rendelesek ]
import Rendelesek from './views/Rendelesek/Rendelesek';
import RendelesBase from './views/Rendelesek/RendelesBase';
import SzallitoiForm from './views/Rendelesek/Szallitoi/SzallitoiForm';
import AjanlatForm from './views/Rendelesek/Vevoi/AjanlatForm';
import EmailBase from './views/Rendelesek/Email/EmailBase';

// MUNKALAP [ /munkalap ]
import Munkalap from './views/Munkalap/MunkalapBase';
import MunkalapForm from './views/Munkalap/MunkalapForm';

// KARBANTARTÁS
import KarbantartasMenuBase from './views/Karbantartas/KarbantartasMenuBase';

// FELADATLISTA [ /feladatlista ]
import FeladatlistaMenuBase from './views/Feladatlista/FeladatlistaMenuBase';
import FeladatlistaForm from './views/Feladatlista/FeladatlistaForm';

// KEDVEZMÉNY [ /kedvezmeny ]
import KedvezmenyBase from './views/Kedvezmeny/KedvezmenyBase';

// Ügyfélszolgálat [ /ugyfelszolgalat ]
import Ugyfelszolgalat from './views/Ugyfelszolgalat/Ugyfelszolgalat';
import UgyfelszolgalatTabBase from './views/Ugyfelszolgalat/Torzsadatok/UgyfelszolgalatTabBase';
import UgyfelszolgalatContent from './views/Ugyfelszolgalat/Esetek/UgyfelszolgalatContent';
import UgyfelszolgalatForm from './views/Ugyfelszolgalat/Esetek/UgyfelszolgalatForm';

// HIRLEVÉLKEZELÉS
import HirlevelBase from './views/Hirlevel/HirlevelBase';

// Blog [ /blog ]
import BlogBase from './views/Blog/BlogBase';

// PARTNER [ /partner ]
import Partner from './views/Partner/Partner';
import PartnerBase from './views/Partner/PartnerTorzs/PartnerBase';
import PartnertorzsUrlap from './views/Partner/PartnerTorzs/PartnertorzsUrlap';
import GDPRBase from './views/Partner/GDPR/GDPRBase';
import PartnerGDPRBase from './views/Partner/GDPR beallitasok/PartnerGDPRBase';

// // TÖRZSADATOK [ /torzsadatok ]
import Torzsadatok from './views/Torzsadatok/Torzsadatok';
import CikkBase from './views/Torzsadatok/Cikk/CikkBase';
import FoldrajziEgysegBase from './views/Torzsadatok/Foldrajziegyseg/FoldrajziEgysegBase';
import Raktar from './views/Torzsadatok/Raktar/Raktar';
import Bizonylatkezeles from './views/Torzsadatok/Bizonylatkezeles/Bizonylatkezeles';
import PenzMenuBase from './views/Torzsadatok/Penzugy/PenzMenuBase';
import HelyszinBase from './views/Torzsadatok/Helyszin/HelyszinBase';
import HelyszinUrlap from './views/Torzsadatok/Helyszin/HelyszinUrlap';
import SzemelyitorzsBase from './views/Torzsadatok/Szemelyitorzs/SzemelyitorzsBase';
import IdopontfoglaloBase from './views/Torzsadatok/Idopontfoglalo/IdopontfoglaloBase';
import Idopontfoglalas from './views/Torzsadatok/Idopontfoglalo/Idopontfoglalas';
import Lekerdezes from './views/Torzsadatok/Idopontfoglalo/Lekerdezes';
import IdopontfoglaloNaptarBase from './views/Torzsadatok/Idopontfoglalo/Naptar/IdopontfoglaloNaptarBase';
import NaptarBase from './views/Torzsadatok/Naptar/NaptarBase';
import NaptarNezetBase from './views/Torzsadatok/Naptar/NaptarModule/NaptarNezetBase';
import CegadatBase from './views/Torzsadatok/Cegadatok/CegadatBase';
import CegadatForm from './views/Torzsadatok/Cegadatok/CegadatForm';
import FelhasznalokBase from './views/Torzsadatok/Felhasznalok/FelhasznalokBase';
import FelhasznalokForm from './views/Torzsadatok/Felhasznalok/FelhasznalokForm';
import FelhasznalokCsoportForm from './views/Torzsadatok/Felhasznalok/FelhasznalokCsoportForm';

// WEBOLDALAK [ /weboldalak ]
import Weboldalak from './views/Weboldalak/Weboldalak';
import BufeKinalatLista from './views/Weboldalak/Bufekinalat/BufeKinalatListaBase';
import Tevekenysegek from './views/Weboldalak/Tevekenysegek/TevekenysegBase';
import Promociok from './views/Weboldalak/Promociok/Promociok';
import Extracontent from './views/Weboldalak/ExtraContent/ExtracontentBase';

// Számlázás [ /szamlazas ]
import Szamlazas from './views/Szamlazas/Szamlazas';
import NyugtaBase from './views/Szamlazas/Nyugta/NyugtaBase';

// 404 [ * ]
import PublicRoutes from './views/Public/PublicRoutes';

import "bootstrap/dist/css/bootstrap.min.css";
import './css/style.css';
import 'react-widgets/styles.css';
import 'simple-line-icons';
import 'animate.css';

let keycloakJson = new XMLHttpRequest();
keycloakJson.open('GET', process.env.PUBLIC_URL + '/keycloak.json', false);
keycloakJson.send(null);
const keycloak = new Keycloak({
  url: keycloakJson.getResponseHeader('url'),
  realm: keycloakJson.getResponseHeader('realm'),
  clientId: keycloakJson.getResponseHeader('resource')
});

keycloak.init({ checkLoginIframe: false }).then(function(authenticated) {
  if (authenticated || !window.location.pathname.startsWith(process.env.PUBLIC_URL + '/admin')) {
    Lib.MicroServices.keycloak = keycloak;
    /*
     *  STRICT MODE
     */
    // ReactDOM.render(<React.StrictMode><Main /></React.StrictMode>, document.getElementById('root'));
    /*
     *  NORMAL MODE
     */
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(<Main />);
  } else {
    keycloak.login();
  }
}).catch(function() {
});


const Main = (props) => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     Globals: {
  //       Lib: Lib,
  //       keycloak: keycloak,
  //       addError: this.addError,
  //       addSuccess: this.addSuccess,
  //       addWarning: this.addWarning,
  //       addInfo: this.addInfo,
  //       bootstraptableProps: Lib.bootstraptableProps,
  //       public_url: process.env.PUBLIC_URL,
  //       layout: null,
  //       event: null,
  //       init: null,
  //       isPortalReady: false,
  //     }
  //   };
  //   this.notificationSystem = React.createRef();
  //   Lib.MicroServices.errorHandler = err => this._handleServiceErrors(err);
  //   Lib.MicroServices.responseHandler = res => this._handleServiceResponse(res);
  // }

  const notificationSystem = React.useRef(null);
  // const navigate = useNavigate();

  const addError = (message) => {
    notificationSystem.current.addNotification({
      title: 'Hiba',
      message: message,
      level: 'error',
      position: 'br'
    });
  }

  const addSuccess = (message) => {
    notificationSystem.current.addNotification({
      title: 'Sikeres művelet!',
      message: message,
      level: 'success',
      position: 'br'
    });
  }

  const addWarning = (message) => {
    notificationSystem.current.addNotification({
      title: 'Figyelmeztetés!',
      message: message,
      level: 'warning',
      position: 'br'
    });
  }

  const addWarningWithPosAndDismiss = (message, pos, dismissTime) => {
    notificationSystem.current.addNotification({
      title: 'Figyelmeztetés!',
      message: message,
      level: 'warning',
      position: pos,
      autoDismiss: dismissTime
    });
  }

  const addInfo = (message) => {
    notificationSystem.current.addNotification({
      title: 'Információ!',
      message: message,
      level: 'info',
      position: 'br'
    });
  }

  const hasRole = (roles, checkKarb) => {
    for (let i = 0; i < roles.length; i += 1) {
      if (checkKarb) {
        if (keycloak.hasResourceRole('ROLE_' + roles[i] + '_KARB'))
          return true;
      } else {
        if (keycloak.hasResourceRole('ROLE_' + roles[i] + '_LEK'))
          return true;
      }
    }
    return false;
  }

  const hasRoleSpec = (roles) => {
    for (let i = 0; i < roles.length; i += 1) {
      if (keycloak.hasResourceRole('ROLE_' + roles[i])) {
        return true;
      }
    }
    return false;
  }

  const setDefaultActiveTab = (defaultRoles, toggle) => {
    let roles = JSON.parse(JSON.stringify(defaultRoles));
    if (roles && roles.length > 0) {
      roles.every((r) => {
        let hasRoleVar = !r.spec ? hasRole(typeof r.rolename === 'object' ? r.rolename : [r.rolename]) : hasRoleSpec(typeof r.rolename === 'object' ? r.rolename : [r.rolename]);
        if (hasRoleVar) {
          toggle(r.tab);
          return false;
        }
        return true;
      });
    }
  }

  // használat: userQuery().get("PARAMETERNEV") -> visszaadja a PARAMETERNEV értékét az URL-ből
  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const [ Globals, setGlobals ] = useState({
    Lib: Lib,
    keycloak: keycloak,
    hasRole: hasRole,
    hasRoleSpec: hasRoleSpec,
    setDefaultActiveTab: setDefaultActiveTab,
    addError: addError,
    addSuccess: addSuccess,
    addWarning: addWarning,
    addWarningWithPosAndDismiss: addWarningWithPosAndDismiss,
    addInfo: addInfo,
    bootstraptableProps: Lib.bootstraptableProps,
    public_url: process.env.PUBLIC_URL,
    layout: null,
    event: null,
    init: null,
    isPortalReady: false,
    route: undefined,
    useQuery: useQuery,
  })

  const { public_url } = Globals;
  const admin_url = public_url + '/admin';

  const changePortalData = (layout, init, event) => {
    setGlobals({ ...Globals, isPortalReady: true });
    // this.setState({
    //   layout,
    //   init,
    //   event
    // }, () => setGlobals({ ...Globals, isPortalReady: true }));
  }

  const dismissPortal = () => {
    setGlobals({ ...Globals, isPortalReady: false });
  }

  const _handleServiceResponse = (res) => { }

  const _handleServiceErrors = (err) => {
      if (err.status && err.response) {
        let { response } = err;
        switch (err.status) {
          case 400: {
            if (response && response.body && response.body.msg) {
              let { msg } = response.body;
              try {
                msg = JSON.parse((msg.split('\n'))[1]).error;
              } catch (e) { }
              addError(msg);
              break;
            }
            break;
          }
          case 401: {
            // if(keycloak) {
            // keycloak.logout();
            break;
          }
          case 403: {
            addError('Hozzáférés megtagadva!');
            break;
          }
          case 404: {
            // this.addError("Nem elérhető a szolgáltatás!");
            break;
          }
          case 406:
          case 409:
          case 500: {
            if (response && response.body && response.body.msg) {
              let { msg } = response.body;
              try {
                msg = JSON.parse((msg.split('\n'))[1]).error;
              } catch (e) { }
              addError(msg);
              break;
            }
            break;
          }
          case 502: {
            addError('Hálózati hiba!');
            break;
          }
          default: {
            // let { statusText } = response;
            // if (!statusText) statusText = "";
            // let message = "";
            // if (Globals.CommonComponents.Alerts) {
            //   let title = "HIBA - " + status + " " + statusText;
            //   message = response.text ? response.text.substring(0, 100) + " " : "";
            //   if (response.body && response.body.error_description) {
            //     title = "HIBA - " + status + " " + response.body.error;
            //     message = response.body.error_description.substring(0, 50) + "...";
            //   }
            //   if (response.body && response.body.message) {
            //     title = "HIBA - " + status + " " + response.body.error;
            //     message = response.body.message + "... " + response.body.path;
            //   }
            //   if (response.body && response.body.uzenet) {
            //     title =  response.body.uzenet;
            //     message = null; // response.body.tartalom should be handled elsewhere (form specific, etc)
            //     if ([400, 500].indexOf(status) < 0)
            //       message = statusText;
            //   }
            //   //Globals.CommonComponents.Alerts.error(title, message);
            // }
          }
        }
      } else {
        // Globals.CommonComponents.Alerts.error("Ismeretlen hiba történt");
      }
  }

  Lib.MicroServices.errorHandler = err => _handleServiceErrors(err);
  Lib.MicroServices.responseHandler = res => _handleServiceResponse(res);
    // const history = useHistory();
    return (
      <div>
        <NotificationSystem
          ref={notificationSystem}
        />
        {window.location.pathname.includes(admin_url) ? (
          window.location.pathname.includes(admin_url + '/kulsomonitor') ? 
          <Router>
            <Routes>
              <Route path={admin_url +'/kulsomonitor/:eszkozazonosito'} element={<KulsokliensContent {...props} globals={Globals} />} />
            </Routes>
          </Router>: (
         <Router>
         <Routes>
           <Route
             path={admin_url + '*'}
             element={(
               <Full location={window.location} setGlobals={setGlobals} globals={Globals}>
                 <Routes>
                    <Route index element={<Kezdolap globals={Globals} />} />
                      {hasRole(['DASHBOARD_DASHBOARD']) && (
                        <Route path="dashboard">
                          <Route index element={<Dashboard globals={Globals} />} />
                          <Route path="uzenetek" element={<UzenetekBaseView globals={Globals} />} />
                        </Route>
                      )}
                      {hasRole(['ELOADAS_ELOADAS', 'MUSOR_MUSOR', 'MUSOR_TULAJDONSAG', 'JEGY_JEGY']) && (
                        <Route path="esemenyek">
                          <Route index element={<Esemenyek globals={Globals} />} />
                          {hasRole(['ELOADAS_ELOADAS']) && (
                            <Route path="eloadasok">
                              <Route index element={<EloadasBase globals={Globals} />} />
                              <Route path="felvitel" element={<EloadasForm type="FEL" globals={Globals} />} />
                              <Route path="modositas" element={<EloadasForm type="MOD" globals={Globals} />} />
                            </Route>
                          )}
                          {hasRole(['MUSOR_MUSOR', 'MUSOR_TULAJDONSAG']) && (
                            <Route path="musorok" element={<MusorBase globals={Globals} />}>
                              <Route path="felvetel" element={<MusorForm type="FEL" globals={Globals} />} />
                              <Route path="modositas" element={<MusorForm type="MOD" globals={Globals} />} />
                            </Route>
                          )}
                          {hasRole(['JEGY_JEGY']) && (
                            <Route path="jegytipusok" element={<JegyBase globals={Globals} />} />
                          )}
                        </Route>
                      )}
                      {(hasRole(['JEGYVASARLAS_RENDELES', 'JEGYVASARLAS_EMAILSABLON', 'JEGYVASARLAS_RENDELES_MUSOR']) || hasRoleSpec(['JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_XLSX', 'JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_PDF', 'JEGYVASARLAS_RIPORT_FORGALOM_XLSX', 'JEGYVASARLAS_RIPORT_FORGALOM_PDF'])) && (
                        <Route path="jegyertekesites">
                          <Route index element={<Jegyertekesites globals={Globals} />} />
                          {hasRole(['JEGYVASARLAS_RENDELES_MUSOR', 'JEGYVASARLAS_RENDELES']) && (
                            <Route path="helysziniertekesites">
                              <Route index element={<JegyErtekesitesBase globals={Globals} />} />
                              <Route path="rendeles/:rendelesId" element={<JegyeladasBase globals={Globals} changePortalData={changePortalData} dismissPortal={dismissPortal} />} />
                              <Route path=":eventId" element={<JegyeladasBase globals={Globals} changePortalData={changePortalData} dismissPortal={dismissPortal} />} />
                            </Route>
                          )}
                          {hasRoleSpec(['JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_XLSX', 'JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_PDF', 'JEGYVASARLAS_RIPORT_FORGALOM_XLSX', 'JEGYVASARLAS_RIPORT_FORGALOM_PDF']) && (
                            <Route path="lekerdezesek" element={<ListakContent globals={Globals} />} />
                          )}
                          {hasRole(['JEGYVASARLAS_EMAILSABLON']) && (
                            <Route path="emailsablonok" element={<EmailSablonContent globals={Globals} />} />
                          )}
                        </Route>
                      )}
                      {(hasRole(['TEREMBERLES_TEREMBERLES']) || hasRoleSpec(['TEREMBERLES_FIZ_KARB'])) && (
                        <Route path="teremberles" element={<TeremberlesBase globals={Globals} />} />
                      )}
                      {hasRoleSpec(['JEGYVASARLAS_JEGYCONTROL']) && (
                        <Route path="jegyellenorzes" element={<JegyellenorzesContent globals={Globals} />} />
                      )}
                      {(hasRole(['KESZLETNYILV_SELEJTEZES', 'KESZLETNYILV_BEVETELEZES', 'KESZLETNYILV_CSOKKENES', 'KESZLETNYILV_KESZLETINFO', 'KESZLETNYILV_LELTAR'])
                        // || hasRoleUnique('ROLE_RAKTAR_RAKTARLISTA_LEK') 
                        || hasRoleSpec(['KESZLETNYILV_LELTAR_LEK'])) && (
                        <Route path="keszlet">
                          <Route index element={<Keszlet globals={Globals} />} />
                          <Route path="keszletkezeles">
                            <Route index element={<Keszletkezeles globals={Globals} />} />
                            {hasRole(['KESZLETNYILV_BEVETELEZES']) && (
                              <Route path="bevetelezes">
                                <Route path="felvetel" element={<BevetelezesBase globals={Globals} felvetel="true" modositas="false" />} />
                                <Route path="modositas" element={<BevetelezesBase globals={Globals} felvetel="false" modositas="true" />} />
                              </Route>
                            )}
                            {hasRole(['KESZLETNYILV_CSOKKENES']) && (
                              <Route path="csokkenes">
                                <Route path="felvetel" element={<KeszletcsokkenesBase globals={Globals} felvetel="true" modositas="false" />} />
                                <Route path="modositas" element={<KeszletcsokkenesBase globals={Globals} felvetel="false" modositas="true" />} />
                              </Route>
                            )}
                            {hasRole(['KESZLETNYILV_SELEJTEZES']) && (
                              <Route path="selejtezes">
                                <Route path="felvetel" element={<SelejtezesBase globals={Globals} felvetel="true" modositas="false" />} />
                                <Route path="modositas" element={<SelejtezesBase globals={Globals} felvetel="false" modositas="true" />} />
                              </Route>
                            )}
                            {hasRole(['KESZLETNYILV_LELTAR']) && (
                              <Route path="leltar">
                                <Route path="felvetel" element={<LeltarForm globals={Globals} type="FEL" />} />
                                <Route path="modositas" element={<LeltarForm globals={Globals} type="MOD" />} />
                              </Route>
                            )}
                          </Route>
                          {hasRole(['KESZLETNYILV_KESZLETINFO']) && (
                            <Route path="keszletinformacio" element={<Keszletinformacio globals={Globals} />} />
                          )}
                          {/* {hasRoleUnique('ROLE_RAKTAR_RAKTARLISTA_LEK') && (
                            <Route path="raktarlista" element={<RaktarkeszletBase globals={Globals} />} />
                          )} */}
                        </Route>
                      )}
                      {(hasRole(['BUFE_BUFE', 'BUFE_KOZOS', 'BUFE_KINALAT', 'BUFE_NTAK_RMS_NAPLO']) || hasRoleSpec(['BUFE_FORGALOMOSSZ', 'BUFE_FORGALOMRESZ', 'BUFE_ELADASLISTA'])) && (
                        <Route path="bufe">
                          <Route index element={<Bufe globals={Globals} />} />
                          {hasRole(['BUFE_BUFE']) && (
                            <Route path="ertekesites" element={<BufeBase globals={Globals} />} />
                          )}
                          {hasRole(['BUFE_BUFE', 'BUFE_KOZOS', 'BUFE_KINALAT']) && (
                            <Route path="termekek" element={<TermekekBase globals={Globals} />} />
                          )}
                          {hasRoleSpec(['BUFE_FORGALOMOSSZ', 'BUFE_FORGALOMRESZ']) && (
                            <Route path="forgalom" element={<ForgalomContent globals={Globals} />} />
                          )}
                          {hasRoleSpec(['BUFE_ELADASLISTA']) && (
                            <Route path="eladasilista" element={<EladasiLista globals={Globals} />} />
                          )}
                          {hasRole(['BUFE_NTAK_RMS_NAPLO']) && (
                            <Route path="ntak" element={<NTAKBase globals={Globals} />} />
                          )}
                        </Route>
                      )}
                      {(hasRole(['KEDVEZMENY_KEDVEZMENY', 'KEDVEZMENY_VKTIPUS', 'KEDVEZMENY_VK', 'KEDVEZMENY_VKGEN', 'KEDVEZMENY_FUNKKEDV'])
                      || hasRoleSpec(['KEDVEZMENY_LISTA_FORGALOM', 'KEDVEZMENY_LISTA_FELHASZNALAS'])) && (
                        <Route path="kedvezmeny" element={<KedvezmenyBase globals={Globals} />} />
                      )}
                      {(hasRole([
                        'RENDELES_SZALLITOI', 'RENDELES_AJANLAT', 'RENDELES_VEVOI', 'RENDELES_EMAILSABLON'
                      ]) || hasRoleSpec(['RENDELES_BEALLITAS'])) && (
                        <Route path="rendelesek">
                          <Route index element={<Rendelesek />} />
                          {(hasRole(['RENDELES_SZALLITOI', 'RENDELES_AJANLAT', 'RENDELES_VEVOI']) || hasRoleSpec(['RENDELES_BEALLITAS'])) && (
                            <Route path="rendeles">
                              <Route index element={<RendelesBase globals={Globals} />} />
                              {hasRole(['RENDELES_SZALLITOI']) && (
                                <Route path="szallitoi">
                                  <Route path="felvetel" element={<SzallitoiForm globals={Globals} type="FEL" />} />
                                  <Route path="modositas" element={<SzallitoiForm globals={Globals} type="MOD" />} />
                                </Route>
                              )}
                              {(hasRole(['RENDELES_AJANLAT'])) && (
                                <Route path="vevoi/ajanlat">
                                  <Route path="felvetel" element={<AjanlatForm globals={Globals} type="FEL" />} />
                                  <Route path="modositas" element={<AjanlatForm globals={Globals} type="MOD" />} />
                                </Route>
                              )}
                            </Route>
                          )}
                          {hasRole(['RENDELES_EMAILSABLON']) && (
                            <Route path="email" element={<EmailBase globals={Globals} />} />
                          )}
                        </Route>
                      )}
                      {(hasRole(['MUNKALAP_OSSZ']) || hasRoleSpec(['MUNKALAP_SAJAT_KARB'])) && (
                        <Route path="munkalap">
                          <Route index element={<Munkalap globals={Globals} />} />
                          <Route path="megtekintes" element={<MunkalapForm globals={Globals} type="VIEW" />} />
                          <Route path="felvetel" element={<MunkalapForm globals={Globals} type="FEL" />} />
                          <Route path="modositas" element={<MunkalapForm globals={Globals} type="MOD" />} />
                        </Route>
                      )}
                      {hasRole(['KARBANTARTAS_KARBANTARTAS', 'KARBANTARTAS_ALKALOM', 'KARBANTARTAS_ELLENORZESILISTA']) && (
                        <Route path="karbantartas" element={<KarbantartasMenuBase globals={Globals} />} />
                      )}
                     
                      {hasRole(['FELADATLISTA_FELADAT', 'FELADATLISTA_FELADATTIPUS']) && (
                        <Route path="feladatlista">
                          <Route index element={<FeladatlistaMenuBase globals={Globals} />} />
                          <Route path="felvetel" element={<FeladatlistaForm globals={Globals} type="FEL" />} />
                          <Route path="modositas" element={<FeladatlistaForm globals={Globals} type="MOD" />} />
                          <Route path="masolas" element={<FeladatlistaForm globals={Globals} type="MAS" />} />
                        </Route>
                      )}
                      
                      
                      {hasRole(['UGYFELSZOLGALAT_ESET', 'UGYFELSZOLGALAT_ALLAPOT', 'UGYFELSZOLGALAT_ELERHETOSEG', 'UGYFELSZOLGALAT_ESETTIPUS']) && (
                        <Route path="ugyfelszolgalat">
                          <Route index element={<Ugyfelszolgalat globals={Globals} />} />
                            {hasRole(['UGYFELSZOLGALAT_ESET']) && (
                              <React.Fragment>
                                <Route path="esetek" element={<UgyfelszolgalatContent globals={Globals} />} />
                                <Route path="felvitel" element={<UgyfelszolgalatForm globals={Globals} type="FEL" />} />
                                <Route path="modositas" element={<UgyfelszolgalatForm globals={Globals} type="MOD" />} />
                                <Route path="szerkesztes" element={<UgyfelszolgalatForm globals={Globals} type="SZERK" />} />
                              </React.Fragment>
                            )}
                            {hasRole(['UGYFELSZOLGALAT_ALLAPOT', 'UGYFELSZOLGALAT_ELERHETOSEG', 'UGYFELSZOLGALAT_ESETTIPUS']) && (
                              <Route path="torzsadatok" element={<UgyfelszolgalatTabBase globals={Globals} />} />
                            )}
                        </Route>
                      )}
                      {hasRole(['HIRLEVEL_HIRLEVEL']) && (
                        <Route path="hirlevelkezeles" element={<HirlevelBase globals={Globals} />} />
                      )}
                      {hasRole(['BLOG_BLOG'], true) && (
                        <Route path="blog" element={<BlogBase globals={Globals} />} />
                      )}
                      {hasRole(['PARTNER_CSOPORT', 'PARTNER_TORZS', 'GDPR_NAPLO', 'GDPR_PROFIL', 'GDPR_JOGALAP']) && (
                        <Route path="partner">
                          <Route index element={<Partner globals={Globals} />} />
                          {(hasRole(['PARTNER_TORZS', 'PARTNER_CSOPORT'])) && (
                            <Route path="partnertorzs">
                              <Route index element={<PartnerBase globals={Globals} />} />
                              <Route path="felvitel" element={<PartnertorzsUrlap globals={Globals} type="FEL" />} />
                              <Route path="modositas" element={<PartnertorzsUrlap globals={Globals} type="MOD" />} />
                            </Route>
                          )}
                          {hasRole(['GDPR_NAPLO']) && (
                            <Route path="GDPR" element={<GDPRBase globals={Globals} />} />
                          )}
                          {hasRole(['GDPR_PROFIL', 'GDPR_JOGALAP']) && (
                            <Route path="GDPR_beallitasok" element={<PartnerGDPRBase globals={Globals} />} />
                          )}
                        </Route>
                        )}
                         
                      {(hasRole([
                        'CEGADAT_CEGADAT',
                        'CIKK_TORZS',
                        'CIKK_CSOPORT',
                        'CIKK_PROFIL',
                        'CIKK_AFA',
                        'RAKTAR_RAKTAR',
                        'BIZONYLAT_TOMB',
                        'BIZONYLAT_TIPUS',
                        'PENZUGYKOZOS_PENZNEM',
                        'PENZUGYKOZOS_FIZMOD',
                        'PENZUGYKOZOS_INFLACIO',
                        'PENZUGYKOZOS_BANKTIPUS',
                        'PENZUGYKOZOS_BANKSZAMLA',
                        'BANK_PENZTAR',
                        'HELYSZIN_HELYSZIN',
                        'HELYSZIN_TEREM',
                        'JEGYTERMEK_SZEKTOR',
                        'HELYSZIN_KULSOKLIENS',
                        'SZERVEZET_SZEMELYI',
                        'TELEPULES_ORSZAG',
                        'TELEPULES_TELEPULES',
                        'BUFE_KOZOS',
                        'BUFE_KINALAT',
                        'IDOPONT_SZOLGALTATAS',
                        'IDOPONT_DOLGOZO',
                        'NAPTAR_NAPTAR_ESEMENY_TIPUS'
                        ]) || hasRoleSpec(['BUFE_FORGALOMOSSZ', 'BUFE_FORGALOMRESZ', 'BUFE_ELADASLISTA']) || hasRole(['CONFIG_USER'], true)) && (
                        <Route path="torzsadatok">
                          <Route index element={<Torzsadatok globals={Globals} />} />
                          {hasRole(['CIKK_TORZS', 'CIKK_CSOPORT', 'CIKK_AFA', 'CIKK_PROFIL']) && (
                            <Route path="cikk" element={<CikkBase globals={Globals} />} />
                          )}
                          
                          {hasRole(['TELEPULES_ORSZAG', 'TELEPULES_TELEPULES']) && (
                            <Route path="foldrajziegyseg" element={<FoldrajziEgysegBase globals={Globals} />} />
                          )}
                          {hasRole(['RAKTAR_RAKTAR']) && (
                            <Route path="raktar" element={<Raktar globals={Globals} />} />
                          )}
                          {hasRole(['BIZONYLAT_TOMB', 'BIZONYLAT_TIPUS']) && (
                            <Route path="bizonylatkezeles" element={<Bizonylatkezeles globals={Globals} />} />
                          )}
                          {hasRole(['PENZUGYKOZOS_FIZMOD', 'PENZUGYKOZOS_PENZNEM', 'PENZUGYKOZOS_INFLACIO', 'PENZUGYKOZOS_BANKTIPUS', 'PENZUGYKOZOS_BANKSZAMLA', 'BANK_PENZTAR']) && (
                            <Route path="penzugy" element={<PenzMenuBase globals={Globals} />} />
                          )}
                          {hasRole(['HELYSZIN_HELYSZIN', 'HELYSZIN_TEREM', 'JEGYTERMEK_SZEKTOR', 'HELYSZIN_KULSOKLIENS']) && (
                            <Route path="helyszin">
                              <Route index element={<HelyszinBase globals={Globals} />} />
                              <Route path="felvitel" element={<HelyszinUrlap globals={Globals} modositas={false} />} />
                              <Route path="modositas" element={<HelyszinUrlap globals={Globals} modositas />} />
                            </Route>
                          )}
                          {hasRole(['SZERVEZET_SZEMELYI']) && (
                            <Route path="szemelyitorzs" element={<SzemelyitorzsBase globals={Globals} />} />
                          )}
                          {hasRole(['CEGADAT_CEGADAT']) && (
                            <Route path="cegadatok">
                              <Route index element={<CegadatBase globals={Globals} />} />
                              <Route path="felvetel" element={<CegadatForm globals={Globals} type="FEL" />} />
                              <Route path="modositas" element={<CegadatForm globals={Globals} type="MOD" />} />
                            </Route>
                          )}
                          {hasRole(['CONFIG_USER'], true) && (
                            <Route path="felhasznalok">
                              <Route index element={<FelhasznalokBase globals={Globals} />} />
                              <Route path="felhasznalo">
                                <Route path="felvetel" element={<FelhasznalokForm globals={Globals} type="FEL" />} />
                                <Route path="modositas" element={<FelhasznalokForm globals={Globals} type="MOD" />} />
                              </Route>
                              <Route path="csoport">
                                <Route path="felvetel" element={<FelhasznalokCsoportForm globals={Globals} type="FEL" />} />
                                <Route path="modositas" element={<FelhasznalokCsoportForm globals={Globals} type="MOD" />} />
                              </Route>
                            </Route>
                          )}
                          {hasRole(['IDOPONT_SZOLGALTATAS', 'IDOPONT_DOLGOZO']) && (
                            <Route path="idopontfoglalo" element={<IdopontfoglaloBase globals={Globals} />} />
                          )}
                          {hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS']) && (
                            <Route path={'naptar'} title="Naptár" element={<NaptarBase globals={Globals} />} />
                          )}
                        </Route>
                      )}
                      {hasRoleSpec(['KULTIK_TEVEKENYSEG', 'KULTIK_BUFE', 'KULTIK_PROMOCIOK', 'KULTIK_EXTRACONTENT']) && (
                        <Route path="weboldalak">
                          <Route index element={<Weboldalak globals={Globals} />} />
                            {hasRoleSpec(['KULTIK_BUFE']) && (
                              <Route path="bufekinalat" element={<BufeKinalatLista globals={Globals} />} />
                            )}
                            {hasRoleSpec(['KULTIK_TEVEKENYSEG']) && (
                              <Route path="tevekenysegek" element={<Tevekenysegek globals={Globals} />} />
                            )}
                            {hasRoleSpec(['KULTIK_PROMOCIOK']) && (
                              <Route path="promociok" element={<Promociok globals={Globals} />} />
                            )}
                            {hasRoleSpec(['KULTIK_EXTRACONTENT']) && (
                              <Route path="extra" element={<Extracontent globals={Globals} />} />
                            )}
                        </Route>
                      )}
                      {hasRole(['SZAMLAZAS_NYUGTA']) && (
                        <Route path="szamlazas">
                          <Route index element={<Szamlazas globals={Globals} />} />
                          <Route path="nyugta" element={<NyugtaBase globals={Globals} />} />
                        </Route>
                      )}
                      {hasRole(['IDOPONT']) && ((
                        <Route path={"idopont"}>
                          <Route index element={<Idopontfoglalas globals={Globals} />} />
                            {hasRole(['IDOPONT']) && (
                              <Route path="idopontfoglalo" element={<IdopontfoglaloNaptarBase globals={Globals} />} />
                            )}
                            {hasRoleSpec(['IDOPONT_STATISZTIKA']) && (
                              <Route path="lekerdezes" element={<Lekerdezes globals={Globals} />} />
                            )}
                        </Route>
                      ))}
                      {hasRole(['NAPTAR_NAPTAR']) && (
                        <React.Fragment>
                          <Route path={'naptar'} title="Naptár" element={<NaptarNezetBase globals={Globals} />} />
                        </React.Fragment>
                      )}
                    </Routes>
                  </Full>
                )}
              />
         </Routes>
       </Router>
        )
        ) : (
          <Router>
            <Routes>
              <Route path={`${public_url}*`} element={<PublicRoutes {...props} globals={Globals} />} />
            </Routes>
          </Router>
        )}
      </div>
    );
}

export default Main;
